var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.OCSDateTime = {
    previous_epoch_time: 0,
    time_settings: {
        start: 0, // Set to 0 for current - time duration, otherwise it will start everything from a historical specific time
        current: 0,
        end: 0 // Set to 0 for live, otherwise it will terminate everything at a historical specific time
    },
    anchor_attributes_to_anchor: function (in_attr, duration) {
        var out = {};
        var ts = this.date_long_string_to_epoch(in_attr.date);
        if (in_attr.type === "loopTo") {
            out.end = ts;
            out.start = ts - duration;
        }
        if (in_attr.type === "loopFrom") {
            out.start = ts;
            out.end = ts + duration;
        }
        return out;
    },

    calculate_start_time: function () {
        // Based off the end epoch time, as this can be extended and given a different end time behavior
        return this.get_end_epoch_time() - this.get_time_duration();
    },
    date_long_string_to_epoch: function (date_string) {
        date_string = date_string.replace(/\//g, "-");
        date_string = date_string.replace('%20', ' ');
        return moment(date_string, 'YYYY-MM-DD HH:mm:ss ZZZ').valueOf();
    },
    process_incomming_number: function (in_time) {
        if (in_time) {
            if (typeof in_time === "number" && !isNaN(parseFloat(in_time)) && isFinite(in_time) && Math.floor(in_time) === in_time) {
                return in_time;
            }
            if (typeof in_time === 'string' || in_time instanceof String) {
                return in_time.toInt();
            }
        }
        return 0;
    },
    time_attributes_to_milliseconds: function (in_attr) {
        var out_value;
        if (in_attr.units === 'day') {
            out_value = parseInt(in_attr.value) * 24 * 60 * 60 * 1000;
        }
        if (in_attr.units === 'hour') {
            out_value = parseInt(in_attr.value) * 60 * 60 * 1000;
        }
        if (in_attr.units === 'min' || in_attr.units === 'minute') {
            out_value = parseInt(in_attr.value) * 60 * 1000;
        }
        if (in_attr.units === 'sec' || in_attr.units === 'second') {
            out_value = parseInt(in_attr.value) * 1000;
        }
        return out_value;
    },
    time_update: function () {
        if (!this.options.anchor) {
            var settings = {start: 0, end: 0};
            var current_value = 0;
            if (!this.options.move_current_epoch_time_forward) {
                current_value = this.time_settings.current;
            }
            settings.current = current_value;
            this.time_settings = settings;
        }
        this.fireEvent('time_update', this);
    },
    /*
     * 
     * Get / Set Methods
     * 
     */
    get_animation_loop_length: function () {
        return this.options.animation_loop_length;
    },
    get_animation_step: function () {
        return this.options.animation_step;
    },
    get_current_epoch_time: function () {
        if (!this.time_settings.current) {
            if (this.options.current_time_ratio) {
                this.set_current_epoch_time(this.get_server_epoch_time());
            } else {
                this.set_current_epoch_time(this.get_start_epoch_time());
            }
        }
        return this.time_settings.current;
    },
    get_current_time_settings: function () {
        return {start: this.get_start_epoch_time(), current: this.get_current_epoch_time(), end: this.get_end_epoch_time()};
    },
    get_display_time_string: function (in_time) {
        return this.get_display_time_string_with_format(this.process_incomming_number(in_time), this.options.display_time_format);
    },
    get_display_time_string_with_format: function (in_time, in_format) {
        var time = moment(this.process_incomming_number(in_time));
        return time.format(in_format);
    },
    /**
     * Returns the current end or latest time in epoch time.
     * @returns {Number} - The end or latest time.
     */
    get_end_epoch_time: function () {
        if (!this.time_settings.end) {
            this.time_settings.end = this.get_server_epoch_time();
        }
        return this.time_settings.end;
    },
    get_frame_from_timestamp: function (ts) {
        if (typeof ts === 'string' || ts instanceof String) {
            ts = ts.toInt();
        }
        return ts - ts % this.options.animation_step;
    },
    /**
     * Get the current time on the client computer
     * @returns {Number} - the client time
     */
    get_local_epoch_time: function () {
        return new Date().getTime();
    },
    get_local_now_display_time_string: function () {
        return this.get_display_time_string(this.get_local_epoch_time());
    },
    /**
     * Get the current time relative to the server
     * @returns {Number}
     */
    get_server_epoch_time: function () {
        return new Date().getTime() + this.options.server_to_local_offset;
    },
    get_server_now_utc_time_string: function () {
        return this.get_display_time_string(this.get_server_epoch_time());
    },
    get_server_to_local_offset: function () {
        return this.options.server_to_local_offset;
    },
    /**
     * Returns the current start or earliest time in epoch time.
     * @returns {Number} - the start or earliest time
     */
    get_start_epoch_time: function () {
        if (!this.time_settings.start) {
            this.time_settings.start = this.calculate_start_time();
        }
        return this.time_settings.start;
    },
    get_time_duration: function () {
        return this.options.duration;
    },
    get_utc_long_string: function (in_time) {
        return this.get_utc_string_with_format(this.process_incomming_number(in_time), this.options.long_time_format);
    },
    get_utc_string_with_format: function (in_time, in_format) {
        var time = moment(this.process_incomming_number(in_time));
        return time.utc().format(in_format);
    },
    get_utc_YmdHM_string: function (in_time) {
        return this.get_utc_string_with_format(this.process_incomming_number(in_time), this.options.YmdHM_time_format);
    },
    /**
     * Set and anchor in time to reference against.
     * 
     * @param {Number} val - Epoch time to be locked to as an ending time. If 0 or less the anchor will be set to false.
     */
    set_anchor: function (val) {
        if (val > 1) {
            // If its a number set it as the end time, otherwise set true or false, 
            //    we first have to turn the anchor off, so the time can be adjusted
            this.time_settings.end = val;
            this.options.anchor = true;
        } else {
            this.options.anchor = false;
        }
        this.time_update();
    },
    set_animation_loop_length: function (val) {
        this.options.animation_loop_length = val;
    },
    set_current_epoch_time: function (value) {
        var start = this.get_frame_from_timestamp(this.get_start_epoch_time());
        var end = this.get_frame_from_timestamp(this.get_end_epoch_time());
        value = this.get_frame_from_timestamp(value);
        // Don't allow a value to be set greater then or less than start
        if (value <= start) {
            value = start;
            this.options.current_time_ratio = 0;
        }
        if (value >= end) {
            value = end;
            this.options.current_time_ratio = 1;
        }

        if (value === start || value === end) {
            this.options.move_current_epoch_time_forward = true;
        } else {
            this.options.move_current_epoch_time_forward = false;
        }
        this.previous_epoch_time = this.time_settings.current;
        // Now that all the conditions have been set, set the value
        this.time_settings.current = value;

    },
    /**
     * 
     * @param {Object} time_settings - The time settings
     * @param {Number} time_settings.start - Start or beginning of the time frame we are interested in. The number should be in epoch time.
     * @param {Number} time_settings.current - The current time. The number should be in epoch time.
     * @param {Number} time_settings.end - End or latest of the time frame we are interested in. The number should be in epoch time.
     * @param {Boolean} anchor - Whether or not to anchor the time settings to the inputted values
     */
    set_current_time_settings: function (time_settings, anchor) {
        if (anchor === false) {
            this.set_anchor(false);
            this.time_update();
            return;
        }

        if (time_settings && time_settings.start) {
            this.time_settings.start = time_settings.start;
        }
        if (time_settings && time_settings.current) {
            this.time_settings.current = time_settings.current;
        }
        if (time_settings && time_settings.end) {
            this.time_settings.end = time_settings.end;
            if (anchor) {
                this.set_anchor(this.time_settings.end);
            }
        }

        if (time_settings && time_settings.end && time_settings.start) {
            this.set_time_duration_millsecs(time_settings.end - time_settings.start);
        }
        this.time_update();
    },
    set_server_to_local_offset: function (offset) {
        this.options.server_to_local_offset = offset;
    },
    set_time_duration_hours: function (val) {
        this.set_time_duration_millsecs(this.time_attributes_to_milliseconds({units: "hour", value: val}));
    },
    set_time_duration_millsecs: function (val) {
        if (!val) {
            return;
        }
        this.options.duration = val;
        this.options.animation_loop_length = val + 60000;
        this.time_update();
    }
};